import { render, staticRenderFns } from "./UnknownBuilder.vue?vue&type=template&id=c836729a&"
import script from "./UnknownBuilder.vue?vue&type=script&lang=js&"
export * from "./UnknownBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports